export const openExternalLink = (url: string) => window.open(url, '_blank');
